import { Injectable, inject } from '@angular/core';

import { DsLoggingService } from '@cubigo/digital-signage';

import { OAuthLogger } from 'angular-oauth2-oidc';

@Injectable({ providedIn: 'root' })
export class OauthLoggerService implements OAuthLogger {
  private readonly logging = inject(DsLoggingService);

  public debug(..._args: unknown[]): void {
    this.logging.trackEvent('oauth_diagnostic');
  }

  public info(..._args: unknown[]): void {
    this.logging.trackEvent('oauth_diagnostic');
  }

  public log(..._args: unknown[]): void {
    this.logging.trackEvent('oauth_diagnostic');
  }

  public warn(..._args: unknown[]): void {
    this.logging.trackEvent('oauth_warning');
  }

  public error(...args: unknown[]): void {
    this.logging.logError(args.at(-1));
  }
}
